import Clear from "@mui/icons-material/Clear";
import { Divider, styled } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import React, { useMemo } from "react";
import { Button } from "../Button/Button";
import AderantTheme from "../Theme/AderantTheme";
const classes = {
    root: "toolbar-root",
    gutters: "toolbar-gutters",
    toolbar: "toolbar-toolbar"
};
const StyledMuiToolbar = styled(Toolbar)(() => ({
    [`&.${classes.toolbar}`]: {
        display: "inline-flex",
        alignItems: "center"
    },
    [`&.${classes.root}`]: {
        minHeight: 0
    },
    [`&.${classes.gutters}`]: {
        paddingLeft: 11,
        paddingRight: 11
    }
}));
export const GridToolbar = (props) => {
    const { children, numSelected, selectionActions, onClickDeselectRows } = props;
    const selectionToolbar = useMemo(() => (React.createElement("div", { className: "grid-toolbar-selection", style: { display: "inline-flex", alignItems: "stretch", padding: "11px 0px", height: 55 } },
        React.createElement("div", { style: { display: "inline-flex", alignItems: "center" } },
            React.createElement(Button, { onClick: onClickDeselectRows, rounded: true, "aria-label": "Deselect all rows", iconButton: true, startIcon: React.createElement(Clear, { fontSize: "small" }), variant: "outlined", size: "small", "data-testid": "deselect-all-rows" }),
            React.createElement("p", { style: { flex: "1 1 100%", margin: "0px 0px 0px 10px", fontSize: "0.937rem" }, key: "items-selected", className: "grid-toolbar-selection-selectedText" },
                numSelected,
                " selected"),
            React.createElement(Divider, { orientation: "vertical", flexItem: true, style: { margin: "0px 24px", borderColor: AderantTheme.palette.controls.grid.toolbar.borderColor } })),
        React.createElement("div", { style: { display: "inline-flex" }, key: "selection-actions" }, selectionActions))), [selectionActions, onClickDeselectRows, numSelected]);
    return (React.createElement(StyledMuiToolbar, { className: classes.toolbar, classes: {
            root: classes.root,
            gutters: classes.gutters
        } }, numSelected > 0 ? selectionToolbar : children ?? null));
};
